import { SERVICE_URL, WS_SERVICE_URL } from "../environment";
import { State } from "../Model/State";
import { BoardsFactory } from "./BoardsFactory";
import { BoardsService } from "./BoardsService";
import { EventsChannelFactory } from "./EventsChannelFactory";
import { GamesFactory } from "./GamesFactory";
import { GamesService } from "./GamesService";
import { HttpService } from "./HttpService";
import { I18nService } from "./I18nService";
import { MessagesFactory } from "./MessagesFactory";
import { MessagesService } from "./MessagesService";
import { PicturesService } from "./PicturesService";
import { PictureUrlFactory } from "./PictureUrlFactory";
import { PlayerService } from "./PlayerService";
import { PlayersFactory } from "./PlayersFactory";
import { RealTimeService } from "./RealTimeService";
import { RoomsFactory } from "./RoomsFactory";
import { RoomsService } from "./RoomsService";
import { ScreenOrientationService } from "./ScreenOrientationService";
import { UuidGenerator } from "./UuidGenerator";
const uuidGenerator = new UuidGenerator();
const screenOrientationService = new ScreenOrientationService();
const INSTANCE_ID = getInstanceId(localStorage);
const httpService = new HttpService(SERVICE_URL);
const realTimeService = new RealTimeService(WS_SERVICE_URL, INSTANCE_ID);
const eventsChannelFactory = new EventsChannelFactory(realTimeService);
const gamesFactory = new GamesFactory(eventsChannelFactory);
const playersFactory = new PlayersFactory();
const roomsFactory = new RoomsFactory(eventsChannelFactory);
const roomsService = new RoomsService(httpService, roomsFactory, gamesFactory, playersFactory);
const playerService = new PlayerService(localStorage, eventsChannelFactory, httpService, playersFactory, INSTANCE_ID);
const picturesService = new PicturesService(uuidGenerator, SERVICE_URL);
const boardsFactory = new BoardsFactory(eventsChannelFactory);
const boardsService = new BoardsService(httpService, playerService, boardsFactory, realTimeService);
const i18nService = new I18nService();
const room = new State(null);
const pictureUrlFactory = new PictureUrlFactory(SERVICE_URL);
const messagesFactory = new MessagesFactory(uuidGenerator);
const messagesService = new MessagesService(httpService, messagesFactory);
const hasBoard = new State(false);
const gamesService = new GamesService(httpService);
// window.addEventListener('focus', () => realTimeService.start());
// window.addEventListener('blur', () => realTimeService.stop());
// if (document.hasFocus()) {
//     realTimeService.start();
// }
export { room, roomsService, hasBoard, eventsChannelFactory, playerService, playersFactory, picturesService, gamesFactory, i18nService, boardsService, realTimeService, pictureUrlFactory, messagesFactory, messagesService, screenOrientationService, gamesService, };
function getInstanceId(storage) {
    if (!storage.getItem('instanceId')) {
        storage.setItem('instanceId', uuidGenerator.createUuid());
    }
    return storage.getItem('instanceId');
}
